import { all, call, takeLatest } from '@redux-saga/core/effects';
import axios from 'axios';
import { fork, put } from 'redux-saga/effects';
import {
  GET_RECEIPT_DATA_REQUEST,
  GET_RECEIPT_DATA_SUCCESS,
  GET_RECEIPT_DATA_FAILURE,
  COMMON_FAILURE,
} from '../../actions';

import { receiptService } from '../../services';

export type getReceiptDataActionType = {
  type: typeof GET_RECEIPT_DATA_REQUEST;
  memberId: string;
  history: string[];
};

function* getReceiptData(action: getReceiptDataActionType): Generator<unknown> {
  try {
    const res = yield call(receiptService(action).getReceiptData);
    yield put({
      type: GET_RECEIPT_DATA_SUCCESS,
      res,
    });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield put({
        type: GET_RECEIPT_DATA_FAILURE,
        error: error.response,
      });
      yield put({
        type: COMMON_FAILURE,
        error: error.response,
      });
    }
    action.history.push('/systemError');
  }
}

function* watchGetReceiptData() {
  yield takeLatest(GET_RECEIPT_DATA_REQUEST, getReceiptData);
}
export default function* getReceiptDataSaga(): Generator<unknown> {
  yield all([fork(watchGetReceiptData)]);
}
